var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('custom-tooltip',{attrs:{"css-class":['pointer'],"section":'search-new-filters-SriRange',"tooltip-text":_vm.$t('search.tips.SRI')}}),_c('sri-risk-indicators',{attrs:{"sri-options":_vm.sriOptions,"value":_vm.rangeValue},on:{"input":_vm.onInput}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }